import { useEffect, useMemo, useState } from "react";
import ShaktiBotFullPanel from "./shaktibot/ShaktiBotFullPanel";
import ShaktiBotLauncher from "./shaktibot/ShaktiBotLauncher";
import ShaktiBotPreviewCard from "./shaktibot/ShaktiBotPreviewCard";
import { DEFAULT_FACTS, MINIMIZE_KEY } from "./shaktibot/constants";

export default function ShaktiPopup() {
  const [hidden, setHidden] = useState(() => {
    try {
      return localStorage.getItem(MINIMIZE_KEY) === "true";
    } catch (e) {
      return false;
    }
  });
  const [mode, setMode] = useState("full");
  const [activeTab, setActiveTab] = useState("knowledge");
  const [index, setIndex] = useState(0);

  const facts = useMemo(() => DEFAULT_FACTS, []);

  useEffect(() => {
    const timer = setInterval(
      () => setIndex((i) => (i + 1) % facts.length),
      8000,
    );
    return () => clearInterval(timer);
  }, [facts.length]);

  useEffect(() => {
    try {
      localStorage.setItem(MINIMIZE_KEY, String(hidden));
    } catch (e) {}
  }, [hidden]);

  useEffect(() => {
    setHidden(false);
    setMode("full");
    setActiveTab("chat");
  }, []);

  const openPreview = () => {
    setHidden(false);
    setMode("full");
  };

  const openFull = (tab) => {
    setHidden(false);
    setActiveTab(tab);
    setMode("full");
  };

  const closeAll = () => {
    setHidden(true);
  };

  return (
    <div className="fixed bottom-6 right-6 z-[9999]">
      {!hidden && mode === "preview" && (
        <ShaktiBotPreviewCard
          onClose={closeAll}
          onOpenChat={() => openFull("chat")}
          onOpenKnowledge={() => openFull("knowledge")}
          tip={facts[index]}
        />
      )}

      {!hidden && mode === "full" && (
        <ShaktiBotFullPanel
          activeTab={activeTab}
          onSetTab={setActiveTab}
          tip={facts[index]}
        />
      )}

      <ShaktiBotLauncher
        hidden={hidden}
        onToggle={() => {
          if (hidden) {
            openPreview();
            return;
          }
          closeAll();
        }}
      />
    </div>
  );
}
